const constants = Object.freeze({
  ADMIN: "admin",
  USER: "user",
});

export default constants;
